import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { SkeletonComponent } from './skeleton.component';
import { VersionOverlayComponent } from './version-overlay.component';
import { DataChartComponent } from './data-chart.component';
import { CommitBarComponent } from './commit-bar.component';
import { KnxNamePipe } from './knx-name.pipe';
import { LinkButtonComponent } from './link-button.component';

@NgModule({
  declarations: [SkeletonComponent, VersionOverlayComponent, DataChartComponent, CommitBarComponent, KnxNamePipe, LinkButtonComponent],
  imports: [CommonModule, HttpClientModule, TranslateModule],
  exports: [SkeletonComponent, VersionOverlayComponent, DataChartComponent, CommitBarComponent, KnxNamePipe, LinkButtonComponent, TranslateModule],
})
export class SharedModule {}
